<template>
    <div>
      <div class="row settings-tabs full-height-tabs">
        <div class="col-lg-12 col-md-12">
          <vue-tabs
            ref="tabs"
            direction="vertical"
            class="row dispatch-tabs full-height-tabs items-align-dispatch-tabs text-align-dispatch-tabs"
            value="Description"
            @tab-change="handleTabChange"
          >
            <v-tab :title="$t('dispath.dispatch')" class="text-left">
              <dispatch v-if="isDispatch" :isDispatch="isDispatch"></dispatch>
            </v-tab>
            <v-tab :title="$t('dispath.addNewOrder')" class="text-left addNewOrder">
              <order-pos v-if="isAddNewOrder" :isAddNewOrder="isAddNewOrder"></order-pos>
            </v-tab>
            <v-tab :title="$t('dispath.drivers')" class="text-left">
              <dispatch-drivers v-if="isDriver" :isDriver="isDriver"></dispatch-drivers>
            </v-tab>
            <v-tab :title="$t('dispath.orders')" class="text-left">
              <dispatch-orders v-if="isOrder" :isOrder="isOrder"></dispatch-orders>
            </v-tab>
            <v-tab :title="$t('dispath.reports')" class="text-left">
              <dispatch-reports v-if="isReport" :isReport="isReport"></dispatch-reports>
            </v-tab>
            <v-tab :title="$t('dispath.settings')" class="text-left">
              <dispatch-settings v-if="isSettings" :isSettings="isSettings"></dispatch-settings>
            </v-tab>
          </vue-tabs>
        </div>
      </div>
    </div>
</template>

  <script>
  import Dispatch from './DispatchView.vue'
  import OrderPos from '../OrdersPos/OrdersPos.vue'
  import DispatchDrivers from './DispatchDrivers.vue'
  import DispatchOrders from './DispatchOrders.vue'
  import DispatchSettings from './DispatchSettings.vue'
  import DispatchReports from './DispatchReports.vue'

  export default {
    components: {
      Dispatch,
      OrderPos,
      DispatchDrivers,
      DispatchOrders,
      DispatchSettings,
      DispatchReports
    },
    data () {
      return {
        isDispatch: false,
        isDriver: false,
        isAddNewOrder: false,
        isOrder: false,
        isReport: false,
        isSettings: false
      }
    },
    mounted () {
      this.switchTab()
    },
    methods: {
      resetStates () {
        this.isDispatch = false
        this.isAddNewOrder = false
        this.isDriver = false
        this.isOrder = false
        this.isReport = false
        this.isSettings = false
      },
      switchTab () {
        const index = this.$route.query.tabIndex
        this.$nextTick(() => {
          if (index && this.$refs.tabs) {
            this.$refs.tabs.navigateToTab(parseInt(index))
          }
        })
      },
      handleTabChange (tabIndex, newTab, oldTab) {
        this.resetStates()
        this.$router.push(`${this.$route.path}?tabIndex=${tabIndex}`)
        switch (newTab.title) {
          case this.$t('dispath.drivers'):
            this.isDriver = true
            break
          case this.$t('dispath.addNewOrder'):
            this.isAddNewOrder = true
            break
          case this.$t('dispath.orders'):
            this.isOrder = true
            break
          case this.$t('dispath.reports'):
            this.isReport = true
            break
          case this.$t('dispath.settings'):
            this.isSettings = true
            break
          default:
            this.isDispatch = true
            break
        }
      }
    }
  }
  </script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Dispatch/Dispatch.vue